module.exports = __webpack_public_path__ + "static/media/01-speaker_profile.31e90c65.webp";